var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "#021317",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2654 0.873757C6.67799 0.747325 2.91975 4.44094 2.91975 9.00152H1.3065C0.900938 9.00152 0.702662 9.48919 0.991064 9.76914L3.50557 12.2978C3.68582 12.4784 3.96521 12.4784 4.14546 12.2978L6.65996 9.76914C6.93935 9.48919 6.74108 9.00152 6.33551 9.00152H4.72226C4.72226 5.47949 7.58826 2.63477 11.1212 2.67993C14.4739 2.72508 17.2948 5.55174 17.3398 8.91121C17.3849 12.4423 14.546 15.3231 11.0311 15.3231C9.58004 15.3231 8.23716 14.8264 7.17368 13.9866C6.81318 13.7066 6.30848 13.7337 5.98402 14.0588C5.60549 14.4381 5.63253 15.0793 6.05612 15.4044C7.42603 16.4881 9.14743 17.1293 11.0311 17.1293C15.5824 17.1293 19.2685 13.3634 19.1424 8.76672C19.0252 4.53125 15.4923 0.991158 11.2654 0.873757ZM10.8057 5.38918C10.4362 5.38918 10.1298 5.69623 10.1298 6.0665V9.38985C10.1298 9.70593 10.301 10.0039 10.5714 10.1665L13.3833 11.8372C13.7078 12.0269 14.1224 11.9185 14.3116 11.6024C14.5009 11.2773 14.3927 10.8619 14.0773 10.6722L11.4817 9.12795V6.05746C11.4817 5.69623 11.1753 5.38918 10.8057 5.38918Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.485bc7020be7d16826109089bf0364d9.svg";
export { ForwardRef as ReactComponent };